import { Box, CardMedia, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'
import { IROVVideoMinimal } from 'src/generated-types/rovvideo'
import { getRovVideoPlaybackSource } from './ROVVideoDalog.action'
import { GenericDialogLayout } from './GenericDialogLayout'
import { RovBlobVideoPlayer } from './RovBlobVideoPlayer'

export interface ROVVideoDalogProps {
  rovvideo: IROVVideoMinimal
}

export const ROVVideoDalog: React.FC<ROVVideoDalogProps> = ({ rovvideo }) => {
  const theme = useTheme()
  const source = getRovVideoPlaybackSource(rovvideo)

  return (
    <>
      <GenericDialogLayout removedCloseButton={true}>
        <Box
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
          }}
        >
          {source.kind === 'blob' && (
            <RovBlobVideoPlayer src={source.url} thumbnailUrl={rovvideo.azureThumbnailURL} title={rovvideo.title} />
          )}
          {source.kind === 'vimeo' && (
            <CardMedia
              component="iframe"
              src={`${process.env.REACT_APP_VIMEO_URL}/${source.vimeoId}`}
              title={rovvideo.title || 'ROV Video'}
              allowFullScreen
              sx={{
                aspectRatio: '16/9',
                border: 0,
              }}
            />
          )}
        </Box>
        <Typography sx={{ fontWeight: 500, marginTop: '16px' }}>{rovvideo.description}</Typography>
      </GenericDialogLayout>
    </>
  )
}
